import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

import useOpenActiveGame from '../games/useOpenActiveGame';

const NO_GAMES_LIMIT = 0;

interface Props {
  tableUrl: string;
  tileScriptId: number;
  shouldCloseOldModalFirst: boolean;
  isFlash: boolean;
}

const useSAGHandleRegisterOpened = ({
  tableUrl,
  tileScriptId,
  shouldCloseOldModalFirst,
  isFlash
}: Props) => {
  const { modal } = useDispatch<Dispatch>();
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const isPlayMoney = useSelector(select.currency.isPlayMoney);
  const openActiveGame = useOpenActiveGame({ tableUrl });

  const handleRegisterOpened = useCallback(() => {
    if (isMobileEmbedded) {
      return window.starsweb?.app?.execute(`sag-reg/${tileScriptId}`);
    }

    if (isDesktopEmbedded) {
      return window.starsweb?.spinandgo?.join({
        selectedId: tileScriptId,
        isFlash,
        isPlayMoney,
        numberOfGames: NO_GAMES_LIMIT
      });
    }

    if (isAuthenticated) {
      openActiveGame();
    } else {
      if (shouldCloseOldModalFirst) {
        modal.close();
      }
      modal.enqueue({ path: '/auth/login' });
    }
  }, [
    isAuthenticated,
    modal,
    shouldCloseOldModalFirst,
    isMobileEmbedded,
    isDesktopEmbedded,
    isFlash,
    isPlayMoney,
    tileScriptId,
    openActiveGame
  ]);

  return handleRegisterOpened;
};

export default useSAGHandleRegisterOpened;
